import { createReducer } from 'utils/reduxCreators';
import { fetchCustomerAccounts } from 'services/accountSearch';
import { updateAppLoading } from './meta';

export const RECEIVED_ACCOUNTS = 'accountSearch/RECEIVED_ACCOUNTS';

const initialState = {
  accounts: [],
};

export default createReducer(initialState, {
  [RECEIVED_ACCOUNTS]: (state, { payload }) => {
    return {
      ...state,
      accounts: payload,
    };
  },
});

export const searchAccounts = (searchText, dob) => async (dispatch) => {
  dispatch(updateAppLoading(true));
  try {
    const accounts = await fetchCustomerAccounts(searchText, dob);
    dispatch(updateAppLoading(false));
    dispatch({ type: RECEIVED_ACCOUNTS, payload: accounts });
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};
